import React from "react";
import Header from "../../components/header/index";
import Main from "../../components/main";
import Section3 from "../../components/section3";
import Section2 from "../../components/section2";
import Section4 from "../../components/section4";
import Section5 from "../../components/section5";
import Footer from "../../components/footer";
import { Grid } from "@mui/material";
export default function index() {
  return (
    <>
      <Header />
      <div>
        <Main />
      </div>
      <div>
        <Section2 />
      </div>
      <div>
        <Section3 />
      </div>
      <div>
        <Section4 />
      </div>
      <div>
        <Section5 />
      </div>

      <Footer />
    </>
  );
}
